import { createCrudApi } from "@/utils/apiFactory"
import { ID, PaginationResult } from "@/types/common"
import { QrCode, QrCodeFormData } from "../types"

const baseApi = createCrudApi<QrCode, QrCodeFormData, Partial<QrCodeFormData>>(
  "/qr-codes",
)

const qrCodeApi = {
  async getList(params?: {
    page?: number
    pageSize?: number
    keyword?: string
  }): Promise<PaginationResult<QrCode>> {
    return baseApi.list(params)
  },

  async getById(id: ID): Promise<QrCode | null> {
    return baseApi.getById(id)
  },

  async create(data: QrCodeFormData): Promise<void> {
    await baseApi.create(data)
  },

  async update(id: ID, data: QrCodeFormData): Promise<void> {
    await baseApi.update(id, data)
  },

  async delete(ids: ID[]): Promise<void> {
    await baseApi.delete(ids)
  },
}

export default qrCodeApi
